import { SanityPageSectionType } from "@sourceful/shared-types";
import dynamic from "next/dynamic";
import React from "react";
import GridSection from "./GridSection";
import HeadingSection from "./HeadingSection";
import HeroSection from "./HeroSection";
import ImageGallerySection from "./ImageGallerySection/ImageGallerySection";
import ImageSection from "./ImageSection/ImageSection";
import InformationCardSection from "./InformationCardSection";
import LogoWallSection from "./LogoWallSection";
import ProductFeaturesSection from "./ProductFeaturesSection";
import PullQuoteSection from "./PullQuoteSection";
import SlidesSection from "./SlidesSection";
import TabsSection from "./TabsSection/TabsSection";
import TechnicalContentSection from "./TechnicalContentSection";

// Load dynamic as the server and client complain of mismatched ids
const FAQSection = dynamic(() => import("./FAQSection"), { ssr: false });

interface PageContentProps {
  pageContent: SanityPageSectionType[];
}

const PageContent = ({ pageContent }: PageContentProps) => {
  return (
    <>
      {pageContent.map(section => {
        switch (section._type) {
          case "heroSection":
            return <HeroSection section={section} key={section._key} />;
          case "gridSection":
            return <GridSection key={section._key} section={section} />;
          case "logoWallSection":
            return <LogoWallSection section={section} key={section._key} />;
          case "faqSection":
            return <FAQSection key={section._key} section={section} />;
          case "imageGallerySection":
            return <ImageGallerySection key={section._key} section={section} />;
          case "slidesSection":
            return <SlidesSection key={section._key} section={section} />;
          case "pullQuoteSection":
            return <PullQuoteSection key={section._key} section={section} />;
          case "tabsSection":
            return <TabsSection key={section._key} section={section} />;
          case "imageSection":
            return <ImageSection key={section._key} section={section} />;
          case "headingSection":
            return <HeadingSection key={section._key} section={section} />;
          case "productFeaturesSection":
            return <ProductFeaturesSection key={section._key} section={section} />;
          case "technicalContentSection":
            return <TechnicalContentSection key={section._key} section={section} />;
          case "informationCardSection":
            return <InformationCardSection key={section._key} section={section} />;
          default:
            return null;
        }
      })}
    </>
  );
};

export default PageContent;
